import React from 'react';

function NotFound() {
  return (
    <div style={{ minHeight: '70vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '3rem 1.5rem' }}>
      <div style={{ maxWidth: 560, textAlign: 'center', background: '#fff', borderRadius: 16, boxShadow: '0 12px 40px rgba(0,0,0,0.08)', padding: '2.5rem' }}>
        <h1 style={{ fontSize: '3rem', marginBottom: '0.75rem', color: '#1f2937' }}>404</h1>
        <h2 style={{ fontSize: '1.5rem', marginBottom: '0.75rem', color: '#111827' }}>Page not found</h2>
        <p style={{ fontSize: '1rem', color: '#6b7280', lineHeight: 1.7 }}>
          The page you are looking for does not exist or may have been moved.
        </p>
        <button
          type="button"
          onClick={() => window.history.pushState({}, '', '/')}
          style={{ marginTop: '1.25rem', background: '#2563eb', color: '#fff', border: 'none', borderRadius: 999, padding: '0.8rem 1.4rem', cursor: 'pointer', fontWeight: 600 }}
        >
          Go to homepage
        </button>
      </div>
    </div>
  );
}

export default NotFound;
